module.exports = __webpack_public_path__ + "static/media/exterior1.5fcb619c.webp";